import regeneratorRuntime from "regenerator-runtime";
import Ajaxjs from '../ajax';

export default class MemberOrdersJs {

    constructor() {
        setTimeout(() => {
            $('.ordersreceipt-btn-resend').on('click', (el) => {
                let $curTarget = $(el.target);
                let orderID = $curTarget.attr('data-id');
                let orderNumber = $curTarget.attr('data-number');
                let $popupConfirm = $('#order-resend-confirm-popup');
                if ($popupConfirm.length > 0) {
                    $('#order-resend-confirm-popup .order-number').text(orderNumber);
                    $('#order-resend-confirm-popup .btn-confirm-resend').attr('data-id', orderID);

                    setTimeout(() => {
                        $('#order-resend-confirm-popup #order-resend-confirm-overlay').show();
                        $('#order-resend-confirm-popup .btn-confirm-resend, #order-resend-confirm-popup .resend-headline').show();
                        $('#order-resend-confirm-popup .order-confirm-msg').hide();
                        cscpjs.default.utilsjs.showById('order-resend-confirm-popup');
                    }, 50)
                }
            })

            $('.btn-confirm-resend').on('click', (el) => {
                let $curTarget = $(el.target);
                let orderID = $curTarget.attr('data-id');
                let $popupConfirm = $('#order-resend-confirm-popup');
                if ($popupConfirm.length > 0 && orderID != '') {
                    this.resendReceipt(orderID)
                }
            })
        }, 1000)
    }

    resendReceipt(orderID) {
        $('.item-order-' + orderID).addClass('item-order-opacity');
        $('.btn-resend-' + orderID).hide();
        $('.order-confirm-msg').addClass('d-none');
        $('.order-confirm-loading').removeClass('d-none');

        var url = `${window.location.protocol}//${window.location.host}/Member/MemberOrdersResendReceipt`;
        console.log(url);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                orderID : orderID
            },
            success: function (res) {
                $('.item-order-'+ orderID).removeClass('item-order-opacity');
                $('.btn-resend-' + orderID).show();
                $('.order-confirm-loading').addClass('d-none');
                if (res.Status) {
                    var msgDone = $('.order-confirm-msg').attr('data-msgdone');
                    $('.order-confirm-msg').find('.resp-message').text(msgDone).removeClass('item-order-msg-error');
                } else {
                    $('.order-confirm-msg').find('.resp-message').text(res.Message).addClass('item-order-msg-error');
                }
                $('.order-confirm-msg').show();
                $('#order-resend-confirm-popup .btn-confirm-resend, #order-resend-confirm-popup .resend-headline').hide();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/Controllers/memberOrders.js